import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const CtaSection = () => (
  <section className="py-24 bg-gradient-to-br from-[#E5007D] to-[#c70069] relative overflow-hidden">
    <div className="absolute inset-0">
      <div className="absolute top-10 left-10 w-40 h-40 rounded-full bg-white/5" />
      <div className="absolute bottom-10 right-10 w-60 h-60 rounded-full bg-white/5" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full bg-white/5" />
    </div>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="font-playfair text-3xl md:text-5xl font-bold text-white mb-6">
          Prêt à commander votre gâteau de rêve ?
        </h2>
        <p className="text-white/80 text-lg mb-10 max-w-2xl mx-auto">
          Que ce soit pour un mariage, un anniversaire ou toute autre occasion spéciale, je suis là pour créer le gâteau parfait pour vous.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/commande"
            className="px-10 py-4 bg-white text-[#E5007D] rounded-full font-semibold text-sm hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl flex items-center gap-2"
          >
            Passer une commande
            <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/contact"
            className="px-10 py-4 border-2 border-white text-white rounded-full font-semibold text-sm hover:bg-white/10 transition-all duration-300"
          >
            Nous contacter
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
);

export default CtaSection;
